export default "__VITE_ASSET__QBrqesbF__"